import React, {Component} from 'react';
import error from '@/assets/images/error.png'
import './index.scss'
import {Button} from "antd";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

class No extends Component{
    constructor(props) {
        super(props);
        this.gotoIndex = this.gotoIndex.bind(this);
    }

    gotoIndex(){
        const type = this.props.userList.clerklevel
        if (type == 8 || type == 9) {
            this.props.history.push({
                pathname: '/home',
            });
        } else if (type == 3 || type == 4 || type == 16) {
            this.props.history.push({
                pathname: '/libraryManageHome',
            });
        } else if (type == 10 || type == 11) {
            this.props.history.push({
                pathname: '/homeScore',
            });
        } else {
            this.props.history.push({
                pathname: '/homeProvince',
            });
        }
    }

    render(){
        return (
            <div className={'errorpage'}>
                <img src={error} alt=""/>
                <div>
                    <div className={'h1'}>404</div>
                    <div className={'h2'}>页面丢失</div>
                    <div className={'h3'}>
                        您所访问的页面不存在。你可以点击下面的按钮，返回主页。
                    </div>
                    <Button className={'btns'} onClick={()=>{this.gotoIndex()}}>返回首页</Button>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        userList: state.userList,
    };
};

export default compose(withRouter, connect(mapStateToProps))(No);
